/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ObjectResult } from '../../models/object-result';
import { UpdatePlayerOptionsCommand } from '../../models/update-player-options-command';

export interface ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataStreamingTrue$Params {
      body?: UpdatePlayerOptionsCommand
}

export function apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataStreamingTrue(http: HttpClient, rootUrl: string, params?: ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
  const rb = new RequestBuilder(rootUrl, apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataStreamingTrue.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json;odata.metadata=none;odata.streaming=false');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json;odata.streaming=true', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ObjectResult>;
    })
  );
}

apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataStreamingTrue.PATH = '/api/player/options';
